module.exports = "<section class=\"section\">\n  <div class=\"columns is-multiline\">\n    <app-forum-item class=\"item\" *ngFor=\"let item of items | async\" [item]=\"item\" [id]=\"item.key\">\n    </app-forum-item>\n  </div>\n  <div class=\"navbar-item separator\" *ngIf=\"!isLogged\">\n    <a class=\"button is-success\" routerLink=\"/signup\">Registrarte para compartir tus ideas.</a>\n  </div>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// /mnt/d/Projects/angular/chisparural-foro/src/app/forum/forum-list/forum-list.component.html
// module id = ../../../../../src/app/forum/forum-list/forum-list.component.html
// module chunks = 1